import * as React from 'react'
import config from 'constants/config'
import { addRegionToPath } from 'lib/urlUtils'
import GeoContext from 'contexts/geoContext'
import TextLink from 'components/Luxkit/TextLink'
import Caption from 'components/Luxkit/Typography/Caption'

function LegalText() {
  const { currentRegionCode } = React.useContext(GeoContext)

  const termsURL = config.contentLinks.termsAndConditions.href || addRegionToPath(config.contentLinks.termsAndConditions.to, currentRegionCode)
  const privacyURL = config.contentLinks.privacyPolicy.href || addRegionToPath(config.contentLinks.privacyPolicy.to, currentRegionCode)

  return (
    <Caption colour="neutral-three" variant="medium">
      By continuing, you agree to our <TextLink href={termsURL} rel="noopener noreferrer" target="_blank" weight="regular">Terms & Conditions</TextLink> and{' '}
      <TextLink href={privacyURL} rel="noopener noreferrer" target="_blank" weight="regular">{config.brandConfig.privacyPolicySynonym},</TextLink>{' '}
      and to subscribe to marketing communications for offers, alerts and services.
    </Caption>
  )
}

export default LegalText
